const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const primePbRegisterFactory = require('components/prime_postbooking/prime_pb_register/js/main');
const primePbStaticContentFactory = require('components/prime_postbooking/prime_pb_static_content/js/main');
const recaptchaManager = require('od-modules/users/recaptcha');
const {eventConstants, genericConstants} = require(`../../constants.js`);
const {getEventType} = require('../../utils');

const processTemplateData = ({keys, options}) => ({
    keys,
    options,
});

module.exports = withRenderedMain(BaseView.extend({
    initialize: function() {
        this.bindEvents();
        this.checkConditionToRender();
        this.initRecaptcha();
    },
    selectors: {
        staticContainer: '.static_container',
        formContainer: '.form_container',
        managerContainer: '.postbookingpage_manager',
    },
    events: {
    },
    bindEvents() {
        this.listenTo(this.model, 'change:openRegisterForm', this.onToggleStaticContainer);
        this.listenTo(this.model, 'change:displayConfirmationPage', this.onDisplayConfirmationPage);
        this.listenTo(this.model, 'change:displayErrorPage', this.onDisplayErrorPage);
        this.listenTo(this.model, 'change:userDTO', this.onCreatePostBookingAfterRegistration);
        this.listenTo(this.model, 'change:userType', this.onCheckIfPrimeUser);
        this.listenTo(this.model, 'change:bookingDetailDTO', this.onCheckIfPrimeUser);
    },

    checkConditionToRender() {
        return (this.model.isPrimeFreeForAll()) ?
            this.getFreeAccountForm() : this.decryptToken();
    },

    getFreeAccountForm() {
        this.model.set('membershipType', genericConstants.basicFreeMembershipType);
        this.model.getSubscriptionOffer();
        this.onDisplayFormRegisterPage(false);
    },

    getParamsFromUrl() {
        return Odigeo.History.getFragment().split('/').pop() || null;
    },

    getTokenFromParams(params) {
        const splitter = (regex, text) => text.split(regex);
        const getTokenIndex = (parameters) => parameters.find((param) => param.indexOf('token=') !== -1);
        const getToken = Odigeo._.flow(splitter.bind(this, '&'), getTokenIndex, splitter.bind(this, '='), Odigeo._.last);
        this.model.set('token', getToken(params));
    },

    decryptToken() {
        const params = this.getParamsFromUrl();
        if (!params) {
            this.onDisplayErrorPage();
        } else {
            this.model.getSubscriptionOffer();
            this.getTokenFromParams(params);
            this.onDisplayFormRegisterPage(true);
        }
    },

    initRecaptcha() {
        if (!recaptchaManager.isGRecaptchaInit) {
            recaptchaManager.init();
            recaptchaManager.gRecaptchaLoaded();
        }
    },

    getUpdatedConfirmationKeys() {
        let name;
        let email;
        if (this.model.isBasicFreeAccount()) {
            name = this.model.get('name');
            email = this.model.get('email');
        } else {
            email = Odigeo._.get(this.model.get('bookingDetailDTO'), 'buyer.mail');
            name = Odigeo._.get(this.model.get('bookingDetailDTO'), 'buyer.name');
        }
        const confirmationTitle = Odigeo.Utils.replaceCmsKeyArgs(
            this.model.get('registered')? this.keys.signInConfirmationTitle : this.keys.signUpConfirmationTitle,
            name);
        const confirmationSubtitle = Odigeo.Utils.replaceCmsKeyArgs(
            this.model.get('registered')? this.keys.signInConfirmationSubtitle : this.keys.signUpConfirmationSubtitle,
            email);
        return {confirmationTitle, confirmationSubtitle};
    },

    onDisplayFormRegisterPage(hasToken) {
        this.renderStaticContent();
        this.renderFormRegister();
        if (hasToken) {
            this.model.getBooking();
        }
    },

    onCheckIfPrimeUser() {
        if (this.checkUserTypePremium() && this.model.get('bookingDetailDTO') !== null) {
            this.onDisplayConfirmationPage(true);
        }
    },

    checkUserTypePremium() {
        return this.model.get('userType') === 'PREMIUM';
    },

    onDisplayConfirmationPage(skipTracking) {
        this.displayTemplate(this.getConfirmationTemplate());
        if (skipTracking !== true) {
            this.model.trackPage(eventConstants.registerSuccess);
        }
    },

    getConfirmationTemplate() {
        if (this.checkUserTypePremium()) {
            this.keys.alreadyPrimeTitle = Odigeo.Utils.replaceCmsKeyArgs(this.keys.alreadyPrimeTitle, this.model.get('email'));
            return this.templates.alreadyPrime({
                keys: this.keys,
            });
        }
        return this.templates.confirmation({
            keys: this.getUpdatedConfirmationKeys(),
        });
    },

    onDisplayErrorPage() {
        const template = this.templates.error({
            keys: {
                title: this.keys.pageErrorTitle,
                subtitle: this.keys.pageErrorSubtitle,
            },
        });
        this.displayTemplate(template);
        this.model.trackEvent('error');
        this.model.trackPage(eventConstants.registerError);
    },

    displayTemplate(template) {
        const page = $('#page');
        if (this.model.isMobile()) {
            const header = page.find('.header');
            header.addClass('od-show-header');
        } else {
            const mainLayout = page.find('.od-home-main-layout');
            mainLayout.addClass('odf-bg-base');
        }
        this.$el.find(this.selectors.managerContainer).empty();
        this.$el.find(this.selectors.managerContainer).append(template);
    },

    onToggleStaticContainer() {
        this.$el.find(this.selectors.staticContainer).toggleClass('odf-hidden');
        this.$el.find(this.selectors.formContainer).toggleClass('odf-hidden');
        if (this.model.isMobile()) {
            // new page only for mobile flow
            const pageLabel = this.model.get('openRegisterForm') ? getEventType(this.model.isRegistered(), true) :
                eventConstants.start;
            this.model.trackPage(pageLabel);
        }
    },

    renderStaticContent() {
        this.staticContentWidget = primePbStaticContentFactory.create({
            id: 'prime-pb-static-content',
            el: this.$el.find(this.selectors.staticContainer),
            model: this.model,
        });
    },

    renderFormRegister() {
        this.registerFormWidget = primePbRegisterFactory.create({
            id: 'prime-pb-register',
            el: this.$el.find(this.selectors.formContainer),
            model: this.model,
        });
    },

    onCreatePostBookingAfterRegistration() {
        if (this.model.get('register')) {
            this.model.createPostBookingMember();
        }
    },

}), processTemplateData);
